<template>
  <div class="property_wrap">
    <div class="pro_top">{{property.label}}设置</div>
    <div class="pro_con">
      <el-form label-width="80px">
        <el-form-item label="组件标题:">
          <el-input v-model="property.label"></el-input>
        </el-form-item>
      </el-form>
      <div class="card-body">
        <div class="card-body-list" v-for="(item,index) in property.list" :key="index">
          <el-form label-width="74px">
            <el-form-item label="名片信息:">
              <div class="card-list-box">
                <div class="card-list-left">
                  <div class="card-list-left-input" v-if="item.id">
                    <el-input v-model="item.name" :disabled="true"></el-input>
                    <span class="card-list-left-input-span" @click="chooseCartId(index)">重新选择</span>
                  </div>
                  <div v-else>
                    <el-button size="small" @click="chooseCartId(index)">选择成员</el-button>
                  </div>
                </div>
                <div class="card-list-right">
                  <i class="el-icon-top" v-if="index!==0" @click="changePosition(index,1)"></i>
                  <i class="el-icon-bottom" v-if="property.list.length-1!==index" @click="changePosition(index,2)"></i>
                  <i class="el-icon-close" @click="closeListCard(index)"></i>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="是否跳转:">
              <el-radio-group v-model="item.is_link">
                <el-radio label="1">是（跳转到该成员名片）</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <el-button type="primary" size="small" @click="addcardFn">添加名片</el-button>
    </div>
    <chooseManagerDialog
            :visible.sync="choosedepdialog"
            @userDetail="userDetail"
            v-if="choosedepdialog"
            :typeDialog="typeDialog"
            @choosedepsucess="choosedepsucess"
    ></chooseManagerDialog>
  </div>
</template>
<script>
  import api from "@/api.js";
  import chooseManagerDialog from "@/components/dialog/chooseManagerDialog.vue";

  export default {
    props: ["property"],
    components: {
      chooseManagerDialog
    },
    data() {
      return {
        choosedepdialog: false,
        dialogVisible: false,
        fileList: [],
        radio: '0',
        defultImg: '/static/img/userDefult.png',
        typeDialog: 1, // 1 选择员工 2 选择app管理员
        form: {
          label: '',
          list: []
        }
      };
    },
    watch: {
      // 因为不能直接修改 props 里的属性，所以不能直接把 formData 通过v-model进行绑定
      // 在这里我们需要监听 formData，当它发生变化时，立即将值赋给 data 里的 form
      property: {
        immediate: true,
        handler(val) {
          this.form = val
        }
      }
    },
    created() {
      // name 姓名 position 职位 mobile：手机 pic 图片 is_link 跳转
      if (this.property.list.length === 0) {
        this.form.list.push({id: '', name: '姓名', position: '职位', mobile: '手机号码', pic: this.defultImg, is_link: '0'})
      }
    },
    mounted() {
      // props 是单向数据流，通过触发 update 事件绑定 formData，
      // 将 data 里的 form 指向父组件通过 formData 绑定的那个对象
      // 父组件在绑定 formData 的时候，需要加上 .sync
      this.$emit('update:property', this.form)
    },
    methods: {
      choosedepsucess() {

      },
      addcardFn() {
        this.form.list.push({id: '', name: '姓名', position: '职位', mobile: '手机号码', pic: this.defultImg, is_link: '0'});
      },
      closeListCard(index) {
        this.form.list.splice(index, 1);
      },
      chooseCartId(index) {
        this.clickIndex = index;
        this.choosedepdialog = true;
      },
      userDetail(option) {
        this.axios
            .post(api.employee_detail, {em_id: option.id})
            .then(response => {
              if (response.data.code == 0) {
                // this.form.list.push({id:'',name: '姓名', position: '职位', mobile: '手机号码', pic: this.defultImg, is_link: '0'})
                let option = this.form.list[this.clickIndex];
                option.id = response.data.info.id;
                option.name = response.data.info.name;
                option.position	 = response.data.info.position;
                option.mobile = response.data.info.phone;
                option.pic = response.data.info.pic;
                this.form.list[this.clickIndex] = option;
                this.choosedepdialog = false;
              } else {
              }
            })
            .catch(response => {
            });
      },
      changePosition(index,type){
        // type 1 向上 2 向下
        let list = this.property.list;
        if(type === 1){
          list[index] = list.splice(index-1, 1, list[index])[0];
        }else{
          list[index] = list.splice(index+1, 1, list[index])[0];
        }
      }
    }
  };
</script>

